export const focusFirstAvailableSeat = () => {
  var _document$querySelect;
  (_document$querySelect = document.querySelector('[data-seat-id]:not(:disabled)')) === null || _document$querySelect === void 0 || _document$querySelect.focus();
};
export const focusOnActiveSeatMapTravelerButton = id => {
  const isNumber = typeof id === 'number' && !Number.isNaN(id);
  if (!isNumber) {
    return;
  }
  const selectors = [`#seatMapTravelerButton-${id}`, `#seatMapTravelerListButton-${id}`];
  const button = selectors.map(selector => document.querySelector(selector)).find(Boolean);
  button === null || button === void 0 || button.focus();
};
export const focusOnNextSegmentButton = () => {
  var _document$querySelect2;
  (_document$querySelect2 = document.querySelector(`#saveAndContinue-button`)) === null || _document$querySelect2 === void 0 || _document$querySelect2.focus();
};
const endsWithDot = text => text.endsWith('.');
const removeDot = text => endsWithDot(text) ? text.slice(0, -1) : text;
const addDot = text => !endsWithDot(text) ? `${text}.` : text;
export const announceAllPassengersAreSeated = message => {
  var _liveRegion$textConte;
  if (!message) {
    return;
  }
  const liveRegion = document.querySelector('#live-region-all-passengers-seated');
  if (!liveRegion) {
    return;
  }
  const trimmedMessage = message.trim();
  const currentMessage = ((_liveRegion$textConte = liveRegion.textContent) === null || _liveRegion$textConte === void 0 ? void 0 : _liveRegion$textConte.trim()) || '';
  if (!currentMessage) {
    liveRegion.textContent = trimmedMessage;
    return;
  }
  if (!endsWithDot(currentMessage)) {
    liveRegion.textContent = addDot(currentMessage);
    return;
  }
  liveRegion.textContent = endsWithDot(trimmedMessage) ? removeDot(trimmedMessage) : trimmedMessage;
};
export const focusOnFirstCharacteristicButton = () => {
  const selectors = ['#seatMap-characteristics button', '#seatMap-expandLegendButton'];
  const button = selectors.map(selector => document.querySelector(selector)).find(Boolean);
  button === null || button === void 0 || button.focus();
};
//# sourceMappingURL=SeatMapMainContentUtils.js.map